import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import Button from '../../Button';
import Radio from '../../Radio';
import { Descriptions } from 'antd';
import useNotification from '../../../hooks/useNotification';

interface IProps {
  code: any;
  onSubmit: Function;
  cancelPath: string | null;
}

const SystemTreeCodeEditor: FC<IProps> = ({
  code,
  onSubmit,
  cancelPath,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { infoNotification } = useNotification();
  const history = useHistory();
  const location = useLocation();

  const [id, setId] = useState('');
  const [korName, setKorName] = useState('');
  const [engName, setEngName] = useState('');
  const [useYn, setUseYn] = useState(true);

  const idInput = useRef<any>();
  const korNameInput = useRef<any>();
  const engNameInput = useRef<any>();

  useEffect(() => {
    if (code) {
      if (cancelPath) setId(code.detailCode);
      else setId(code.commonCode);
      setKorName(code.korName);
      setEngName(code.engName);
      setUseYn(code.useYn === 'Y');
    }
  }, [code])

  const onSave = async () => {
    if (!id) {
      idInput.current.focus();
      return enqueueSnackbar(t('system.code.message2'), {
        variant: 'info'
      });
    }
    if (cancelPath && id.length > 10) {
      return infoNotification(t('student.student.91'));
    }
    if (!korName) {
      korNameInput.current.focus();
      return enqueueSnackbar(t('system.code.message3'), {
        variant: 'info'
      });
    }

    const req: any = {
      korName,
      engName,
      useYn: useYn ? 'Y' : 'N'
    }

    if (cancelPath) {
      req.detailCode = id;
    } else {
      req.commonCode = id;
    }
    onSubmit(req);
  };

  return (
    <div className="comm-table__area rowType edit mt-1">
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label={`* ${t('system.code.column1')}`}>
          {
            code
              ? cancelPath
                ? code.detailCode
                : code.commonCode
              : (
                <input
                  type="text"
                  className="form-control input-text"
                  value={id}
                  onChange={e => setId(e.target.value)}
                  ref={idInput}
                />
              )
          }
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('system.code.column2')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={korName}
            onChange={e => setKorName(e.target.value)}
            ref={korNameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.code.column3')}>
          <input
            type="text"
            className="form-control input-text"
            value={engName}
            onChange={e => setEngName(e.target.value)}
            ref={engNameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('system.code.column4')}`}>
          <Radio
            checked={useYn}
            onChange={() => setUseYn(true)}
            text={t('common.option.yes')}
          />
          <Radio
            className="ml-4"
            checked={!useYn}
            onChange={() => setUseYn(false)}
            text={t('common.option.no')}
          />
        </Descriptions.Item>
      </Descriptions>

      <div className='comm-bx__space'>
        <div className="comm-btn__area right">
          <Button
            onClick={onSave}
            className="btn-basic pink"
            text={t('common.button.save')}
          />
          <Button
            onClick={() => history.push(cancelPath ? cancelPath : `/system/treecode${location.search}`)}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </div>
  )
}

export default SystemTreeCodeEditor;
